<template>
    <div ref="slot1_container" class="adds-messages-list">
        <ActionButton v-if="AccountController.account.premium.allowed "
            v-tooltip='"messages.ads.tooltip_remove"'
            :gtm="{
                module : 'ads',
                feature: 'ads_remove_modal',
                block  : 'message_list',
                action : 'open'
                }"
            class="close"
            icon="fas fa-times-circle"
            type="icon"
            @click="onRemoveAds()"
        />
        <div class="content">
            <div v-show="slot_item.getFallbackVisibility() === false"
                :id="AdsSlots.GPT_INLINE_BANNER_320_SLOT_1"
                class="GPT_INLINE_BANNER_320_SLOT_1"
            ></div>
            <img v-show="slot_item.getFallbackVisibility() === true"
                :src="slot_item.getFallbackSrc()"
                class="GPT_INLINE_BANNER_320_SLOT_1_FALLBACK"
                alt=""
                @click="onFallbackClick()"/>
        </div>
    </div>
</template>

<script setup>
    import ActionButton              from '@/vue/Elements/Buttons/ActionButton.vue';
    import AccountController         from '@/js/Webmail/AccountController';
    import AdsSlotObserverController from '@/js/Webmail/Ads/AdsSlotObserverController';
    import { ref }                   from 'vue';
    import { onBeforeUnmount }       from 'vue';
    import { onMounted }             from 'vue';
    import { reactive }              from 'vue';
    import DomController             from '@/js/Webmail/DomController';
    import AdsSlots                  from '@/js/Webmail/Ads/AdsSlots';
    import GPTAdsController          from '@/js/Webmail/Ads/GPTAdsController';
    import SlotItem                  from '@/js/Webmail/Ads/Items/SlotItem';
    import SAPOMailConfig            from '../../../SAPOMailConfig.js';

    const slot1_container = ref();
    /** @type {SlotItem} */
    const slot_item       = reactive(new SlotItem());

    const emit = defineEmits(['removeAds']);

    onMounted(() => {
        slot_item.setId(AdsSlots.GPT_INLINE_BANNER_320_SLOT_1);
        slot_item.setElement(slot1_container.value);

        DomController.setBodyClass('hasPub');

        GPTAdsController.addQueue(slot_item);
    });

    onBeforeUnmount(() => {
        GPTAdsController.removeQueue(slot_item);
    });

    const onRemoveAds = () => {
        emit('removeAds');
    };

    const onFallbackClick = () => {
        if (
            SAPOMailConfig.client.ads
            && SAPOMailConfig.client.ads.fallback
            && SAPOMailConfig.client.ads.fallback.links
            && SAPOMailConfig.client.ads.fallback.links.subscricoes
        ) {
            window.open(SAPOMailConfig.client.ads.fallback.links.subscricoes, '_blank');
        }
    };
</script>

<style>
    .adds-messages-list .content {
        display: flex;
        place-content: center;
    }

    .adds-messages-list:has(.GPT_INLINE_BANNER_320_SLOT_1) .content {
        width: calc(100% - 60px);
        margin-left: 30px;
    }

    .adds-messages-list:has(.GPT_INLINE_BANNER_320_SLOT_1)::before {
        content: "Pub";
        position: absolute;
        top: 50%;
        left: 2px;
        z-index: 1;
        font-family: sans-serif;
        font-size: 9px;
        text-transform: uppercase;
        text-align: center;
        color: #999;
    }

    .GPT_INLINE_BANNER_320_SLOT_1 {
        place-content: center;
    }

    .GPT_INLINE_BANNER_320_SLOT_1_FALLBACK {
        display: block;
        max-width: 100%;
        cursor: pointer;
    }
</style>
